<template>
  <div class="flex-grow-1">
    <div class="mb-2">{{ label }}</div>

    <v-btn color="primary" :loading="loading" rounded @click="clickUpload" dark>{{ label }}</v-btn>

    <v-file-input
      v-model="pending_uploads"
      autofocus
      @change="handleUploading"
      counter
      v-show="false"
      multiple
      outlined
      ref="input_file"
      prepend-icon="mdi-camera"
      :display-size="1000"
      :error="error != null"
      :error-messages="error"
    >
      <template v-slot:selection="{ file, index, multiple, text }">
        <v-chip dark label small>{{ text }}</v-chip>
      </template>
    </v-file-input>
    <v-list two-line subheader>
      <draggable v-model="uploaded">
        <v-list-item two-line v-for="item,i in uploaded" :key="item.uuid">
          <v-list-item-avatar tile max-width="120" size="56">
            <v-img :src="item.sm" :aspect-ratio="16/9" max-width="120"></v-img>
          </v-list-item-avatar>
          <v-list-item-icon>
            <v-icon class="mt-4" color="grey">mdi-dots-vertical</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <span>Image #{{ i+1 }}</span>
              <span v-if="i == 0" class="grey--text">({{ trans('advert.primary_image') }})</span>
            </v-list-item-title>
            <v-list-item-subtitle>{{ moment(item.uploaded_at) }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon v-on:click="deleteFile(item.uuid)">
              <v-icon small color="secondary">mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </draggable>
    </v-list>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import _ from "lodash";
import draggable from "vuedraggable";

export default {
  components: {
    draggable
  },

  props: ["label", "value"],

  data: () => ({
    buffer: [],
    pending_uploads: [],
    error: null,
    loading: false
  }),

  computed: {
    uploaded: {
      get: function() {
        // return this.buffer;
        return this.$props.value;
      },
      set: function(payload) {
        this.$emit("input", payload);
      }
    },

    deleting: function() {}
  },

  methods: {
    ...mapActions("media", {
      uploadFile: "upload",
      deleteFile: "delete"
    }),
    clickUpload() {
      if (this.$refs.input_file) {
        const input = this.$refs.input_file.$el.querySelector(
          'input[type="file"]'
        );
        if (input) {
          input.click();
        }
      }
    },
    handleUploading(files) {
      this.loading = true;
      _.each(files, (file, index) => {
        let promise = this.uploadFile({ file, index });
      });
    },

    handleSuccessfullUpload(media) {
      let uploaded = _.cloneDeep(this.uploaded);
      if (uploaded == null) uploaded = [];
      uploaded.splice(0, 0, media);
      this.uploaded = uploaded;

      this.pending_uploads.splice(0, 1);
    },

    handleSuccessfullDelete(uuid) {
      let index = _.findIndex(this.uploaded, e => e.uuid == uuid);
      if (index >= 0) {
        let uploaded = _.cloneDeep(this.uploaded);
        uploaded.splice(index, 1);
        this.uploaded = uploaded;
      }
    },

    onInput: function() {
      this.$emit("input", this.uuids);
    }
  },

  mounted: function() {
    this.$store.subscribe(({ type, payload }, state) => {
      if (type == "media/handleInstanceSaved") {
        this.loading = false;
        this.handleSuccessfullUpload(payload);
      }

      if (type == "media/handleInstanceDeleted") {
        this.loading = false;
        this.handleSuccessfullDelete(payload);
      }

      if (type == "media/handleInstanceFailed") {
        this.loading = false;
        this.error = "Cannot upload image.";
      }
    });
  }
};
</script>